/* eslint-disable */
/* tslint:disable */

import { EmployeeBriefInfo, EmployeeResponse, LongEmployeeListingResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

class Employees<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Получить список всех сотрудников
	 * @request GET:/employees
	 * @secure
	 */
	employeesList = (params: RequestParams = {}) =>
		this.request<EmployeeResponse[], void>({
			path: `/employees`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Cписок сотрудников в коротком формате
	 * @request GET:/employees/short
	 * @secure
	 */
	shortList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			org?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<EmployeeBriefInfo[], void>({
			path: `/employees/short`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Cписок сотрудников в длинном формате
	 * @request GET:/employees/long
	 * @secure
	 */
	longList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			org?: number;
			/** колонка для фильтрации */
			filter_column?: string;
			/** значение из колонки для фильтрации */
			filter_value?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<LongEmployeeListingResponse, void>({
			path: `/employees/long`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Cписок сотрудников в длинном формате (архив)
	 * @request GET:/employees/long/archived
	 * @secure
	 */
	longArchivedList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			org?: number;
			/** колонка для фильтрации */
			filter_column?: string;
			/** значение из колонки для фильтрации */
			filter_value?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<LongEmployeeListingResponse, void>({
			path: `/employees/long/archived`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Сотрудники
	 * @summary Cписок сотрудников в длинном формате (кандидаты на привязку к пользователю)
	 * @request GET:/employees/long/unbound
	 * @secure
	 */
	longUnboundList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			org?: number;
			/** колонка для фильтрации */
			filter_column?: string;
			/** значение из колонки для фильтрации */
			filter_value?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<LongEmployeeListingResponse, void>({
			path: `/employees/long/unbound`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
}
export const employeesAPI = new Employees();
